import React from 'react';
import { formatDateTime } from 'Utils/Utils';
import UserIcon from 'SVGS/UserIcon';
import ClockIcon from 'SVGS/ClockIcon';

const AddendumHistoryItem = ({ addendum, index }) => {
    return (
        <div className="p-2 mb-4 rounded-md border border-gray-200">
            <div className="flex justify-between items-center p-2 mb-2 rounded-md">
                <span className="px-3 py-1 text-sm font-medium text-blue-800 bg-blue-100 rounded-md">
                    Addendum #{index + 1}
                </span>
                 <div className="flex items-center space-x-4 text-sm text-gray-500">
                    <div className="flex items-center">
                        <UserIcon size={16} className="mr-1" />
                        <span>{addendum.updatedBy || 'Unknown User'}</span>
                    </div>
                    <div className="flex items-center">
                        <ClockIcon size={16} className="mr-1" />
                        <span>{formatDateTime(addendum.updatedDate)}</span>
                    </div>
                </div>
            </div>
            <div className="ml-4">
                <p className="mb-2 text-gray-700">{addendum.notes || 'No content available'}</p>
            </div>
        </div>
    );
};

export default AddendumHistoryItem;
